import React from 'react'
import styled from 'styled-components'
import { ContractInfo, VehicleTypes, RelationshipTypes } from 'states/QnState'
import { CONTRACT_INFO_FORM } from 'constants/qnState'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { ConfirmItem, createSelectItem, createSingleItem } from 'utils/qnState'
import { PageMessage } from 'constants/pageMessage'

/**
 * ContractInformationContentのタイプ定義
 */
export type ContractInfoContentProps = {
  /** 契約者情報 */
  contractInfo: ContractInfo
}

/**
 * お客様情報確認用コンテンツ
 */
const ContractInformationContent: React.FC<ContractInfoContentProps> = (
  props
) => {
  const { contractInfo } = props

  // 表示データ
  const items: Array<ConfirmItem | undefined> = [
    // 名前
    createSingleItem(CONTRACT_INFO_FORM.nameKana, contractInfo.nameKana),
    // 電話番号
    createSingleItem(CONTRACT_INFO_FORM.phoneNumber, contractInfo.phoneNumber),
    // 続柄
    createSelectItem(
      CONTRACT_INFO_FORM.relationship,
      contractInfo.relationship
    ),
    //  契約者名
    ...(!contractInfo.relationship.includes(RelationshipTypes.self) &&
    contractInfo.contractorName
      ? [
          createSingleItem(
            CONTRACT_INFO_FORM.contractorName,
            contractInfo.contractorName
          ),
        ]
      : []),

    // 車両種別
    createSelectItem(
      {
        ...CONTRACT_INFO_FORM.vehicleType,
        options: CLIENT_SETTINGS.options.vehicleType,
      },
      contractInfo.vehicleType
    ),
    // ナンバープレート
    createSingleItem(CONTRACT_INFO_FORM.plateNumber, contractInfo.plateNumber),
    // バイクの排気量
    contractInfo.vehicleType.includes(VehicleTypes.motorbike)
      ? createSelectItem(
          CONTRACT_INFO_FORM.bikeDisplacement,
          contractInfo.bikeDisplacement
        )
      : undefined,
    // トラックの積載量、積み荷の量
    ...(contractInfo.vehicleType.includes(VehicleTypes.truck)
      ? [
          createSelectItem(CONTRACT_INFO_FORM.cargo, contractInfo.cargo),
          createSelectItem(
            CONTRACT_INFO_FORM.cargoQuantity,
            contractInfo.cargoQuantity
          ),
        ]
      : []),
    // JAFへの加入
    {
      label: PageMessage['confirmation.jaf.cofirmation'],
      values: [
        contractInfo.jafMembershipConfirmation
          ? PageMessage['common.support-request.yes']
          : PageMessage['common.support-request.no'],
      ],
    },
    // JAFの会員情報
    ...(contractInfo.jafMembershipConfirmation
      ? [
          createSingleItem(
            CONTRACT_INFO_FORM.jafMembershipNumber,
            contractInfo.jafMembershipNumber
          ),
          contractInfo.jafMembershipName
            ? createSingleItem(
                CONTRACT_INFO_FORM.jafMembershipName,
                contractInfo.jafMembershipName
              )
            : undefined,
        ]
      : []),
  ]

  return (
    <>
      {items.map(
        (item, index) =>
          item && (
            <React.Fragment key={index}>
              <ContractInfoItemLabel>{item.label}</ContractInfoItemLabel>
              {item.values.map((item, index) => (
                <ContractInfoItemValue key={index}>
                  <ContractInfoItemValueChild>
                    {item}
                  </ContractInfoItemValueChild>
                </ContractInfoItemValue>
              ))}
            </React.Fragment>
          )
      )}
    </>
  )
}

const ContractInfoItemLabel = styled.div`
  font-weight: bold;
`

const ContractInfoItemValue = styled.ul`
  margin-top: 8px;
`

const ContractInfoItemValueChild = styled.li`
  word-break: break-all;
`

export default React.memo(ContractInformationContent)
